import { render, staticRenderFns } from "./SuratPersetujuanPelepasanInformasiBody.vue?vue&type=template&id=13cc62a2&scoped=true&"
import script from "./SuratPersetujuanPelepasanInformasiBody.vue?vue&type=script&lang=js&"
export * from "./SuratPersetujuanPelepasanInformasiBody.vue?vue&type=script&lang=js&"
import style0 from "./SuratPersetujuanPelepasanInformasiBody.vue?vue&type=style&index=0&id=13cc62a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc62a2",
  null
  
)

export default component.exports